import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link as RouterLink, useLocation, } from 'react-router-dom';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
const routeSeparators = {
    navigateNextIcon: { value: 'navigateNextIcon', label: 'Navigate Next Icon' },
    arrowCircleIcon: { value: 'arrowCircleIcon', label: 'Circle Arrow Icon' },
    doubleArrowIcon: { value: 'doubleArrowIcon', label: 'Double Arrow Icon' },
    arrowRightIcon: { value: 'arrowRightIcon', label: 'Arrow Right Icon' },
    arrowForwardIcon: { value: 'arrowForwardIcon', label: 'Arrow Forward Icon' },
    arrowAltIcon: { value: 'arrowAltIcon', label: 'Arrow Alt Icon' },
    arrowSmall: { value: 'arrowSmall', label: 'Arrow Small' },
    dash: { value: 'dash', label: 'Dash' },
    forwardSlash: { value: 'forwardSlash', label: 'Forward Slash' },
};
const LinkRouter = (props) => (
// eslint-disable-next-line react/jsx-props-no-spreading
_jsx(Link, { ...props, component: RouterLink }));
const CustomBreadCrumbs = ({ settings: { defaultSeparatorValue }, limitToPageWidth }) => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);
    const getSeparator = (value) => {
        switch (value) {
            case routeSeparators.navigateNextIcon.value:
                return _jsx(NavigateNextIcon, { fontSize: "small" });
            case routeSeparators.arrowCircleIcon.value:
                return _jsx(ArrowCircleRightIcon, { fontSize: "small" });
            case routeSeparators.doubleArrowIcon.value:
                return _jsx(DoubleArrowIcon, { fontSize: "small" });
            case routeSeparators.arrowForwardIcon.value:
                return _jsx(ArrowForwardIcon, { fontSize: "small" });
            case routeSeparators.arrowRightIcon.value:
                return _jsx(ArrowRightIcon, {});
            case routeSeparators.arrowAltIcon.value:
                return _jsx(ArrowRightAltIcon, {});
            case routeSeparators.arrowSmall.value:
                return '›';
            case routeSeparators.dash.value:
                return '-';
            case routeSeparators.forwardSlash.value:
                return '/';
            default:
                return '';
        }
    };
    return (_jsxs(Breadcrumbs, { separator: getSeparator(defaultSeparatorValue), "aria-label": "breadcrumb", sx: {
            minHeight: 61,
            backgroundColor: 'primary.main',
            px: 1,
            pt: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            typography: 'subtitle2',
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: [_jsx(LinkRouter, { underline: "hover", color: "text.secondary", fontSize: "inherit", to: "/", children: "Home" }), pathnames.map((value, index) => {
                const last = index === pathnames.length - 1;
                const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                return last ? (_jsx(Typography, { color: "text.secondary", fontSize: "inherit", children: value }, to)) : (_jsx(LinkRouter, { underline: "hover", color: "text.secondary", fontSize: "inherit", to: to, children: value }, to));
            })] }));
};
CustomBreadCrumbs.defaultProps = {
    settings: {
        defaultSeparatorValue: routeSeparators.navigateNextIcon.value,
    },
};
CustomBreadCrumbs.meta = {
    group: 'portal',
    name: 'Breadcrumbs',
    description: 'Shows global history',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.defaultSeparatorValue',
            name: 'Route name separator',
            type: 'array',
            items: routeSeparators,
            description: 'Separator type to show between route names',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Breadcrumbs',
        props: {
            limitToPageWidth: true,
            settings: {
                defaultSeparatorValue: routeSeparators.navigateNextIcon.value,
            },
        },
    },
};
export default CustomBreadCrumbs;
//# sourceMappingURL=Breadcrumbs.js.map